"use strict";

exports.__esModule = true;
exports["default"] = void 0;

/**
 * Finds the first form field within `rootElement` with a validation error
 * (aria-invalid=true) and focuses it.
 * If none are found, it tries to search within the entire document.
 * If none are found at all, it fallbacks to a default errorClass for forms.
 *
 * @param rootElement
 * @param fallbackErrorClass
 */
var focusOnFirstError = function focusOnFirstError(rootElement, fallbackErrorClass) {
  if (fallbackErrorClass === void 0) {
    fallbackErrorClass = '.__form-field-error';
  }

  var firstElementWithValidationError = rootElement.querySelector('[aria-invalid=true]') || document.querySelector('[aria-invalid=true]');

  if (!firstElementWithValidationError) {
    // We'd like to migrate away from this strategy and only use standard aria
    // attributes more standardized methods, but for backward-compatibility,
    // we fallback to a prevalent class.
    var firstErrorWrapper = document.querySelector(fallbackErrorClass);
    firstElementWithValidationError = firstErrorWrapper && (firstErrorWrapper.querySelector('input') || firstErrorWrapper.querySelector('.mce-tinymce') || firstErrorWrapper.querySelector('textarea') || firstErrorWrapper.querySelector('label'));
  }

  if (!firstElementWithValidationError) {
    return;
  }

  focusElement(firstElementWithValidationError);
};

function focusElement(firstElementWithValidationError) {
  var hasTabIndex = !!firstElementWithValidationError.getAttribute('tabIndex');

  if (!hasTabIndex) {
    firstElementWithValidationError.setAttribute('tabIndex', '99');
  }

  firstElementWithValidationError.focus();

  if (!hasTabIndex) {
    firstElementWithValidationError.removeAttribute('tabIndex');
  }
}

var _default = focusOnFirstError;
exports["default"] = _default;